import type { Ruleset } from "@rosette/ts/src/business/game/Ruleset.js";
import { PopupButton } from "@/components/generic/popup/PopupButton.js";
import Image from "next/image";
import { getRulesetIcon } from "@/components/icon/getRulesetIcon.js";
import React from "react";
import { cn } from "@rosette/ts/src/util/cn.js";


interface RulesetPopupButtonProps {
    ruleset: Ruleset;
    rating?: number;
}


export function RulesetPopupButton({ ruleset, rating }: RulesetPopupButtonProps) {
    return (
        <PopupButton
            buttonClassName={cn(
                "flex flex-col-reverse items-start gap-0 min-w-[4em] max-w-[4em] m-0",
                "text-base text-left font-bold text-body",
                "md:flex-row md:items-center md:gap-2 md:min-w-[7.5em] md:max-w-[7.5em]",
            )}
            buttonContent={(
                <>
                    <Image
                        className="w-[3em] min-w-[3em] max-w-[3em] object-contain"
                        src={getRulesetIcon(ruleset)}
                        alt={ruleset.getDesc()} />
                    <p className="m-0">
                        {ruleset.getName()}
                        {rating !== undefined && (
                            <>
                                <br />
                                <span className="text-sm text-muted">
                                    {Math.round(rating).toFixed(0)}
                                </span>
                            </>
                        )}
                    </p>
                </>
            )}>

            <span className="font-bold">
                {`${ruleset.getName()} Rules: `}
            </span>
            <span>
                {ruleset.getDesc()}
            </span>
        </PopupButton>
    );
}
